import { Box, Grid,FormControl,FormLabel } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../common/FormikControl";
import { useDispatch } from "react-redux";
import { updateFeasibility } from "../../../slices/feasibility";
import { useEffect, useState } from "react";
import { SUPPORTED_FORMATS } from "../../../../pages/appointment-details/common-pre-screen/common";
import DownloadImageApi from "../../../../services/downloadImageService"
import  FileUploadComponent from '../../../pages/FeasibilityAssessment/BMRSlots/FileUploadComponent'


const FinancialFeasibiltyForm = ({ id, handleCloseModal, onMarkAsFisable, phase_type, feasibilityInfo }) => {
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({
    feasibility: "",
    payment_type: "",
    comment: ""
  });

  useEffect(() => {
    if (feasibilityInfo) {
      setInitialValues({
        feasibility: feasibilityInfo?.financial_status?.toString() || "",
        payment_type: feasibilityInfo?.financial_payment_type || "",
        comment: feasibilityInfo?.financial_feasibility_comment || ""
      });
    }
  }, [feasibilityInfo]);

      const handleDownload = async (id) => {
      try {
        const imgRes = await DownloadImageApi.getDownloadedImageul(id);
        const response = await fetch(imgRes?.data || "");
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response?.url;
      } catch (error) {
        // console.error("Download failed:", error);
        console.log("Download failed. Please try again later.");
      }
    };

  const validationSchema = Yup.object().shape({
    feasibility: Yup.string().required("Feasibility is required"),
    payment_type: Yup.string().when('feasibility', {
      is: (val) => val === "3" && phase_type != "Trial" || val === "1" && phase_type != "Trial", // Check for both "3" and "1"
      then: Yup.string().required("Payment Type is required"),
      otherwise: Yup.string().notRequired(),
    }),
    comment: Yup.string().required("Comment is required"),
  });


  const feasibilityOptions = [
    { value: '1', label: 'Yes' },
    { value: '2', label: 'No' },
    ...(phase_type === "Trial"
      ? [{ value: '4', label: 'Not Applicable' }]
      : [{ value: '3', label: 'Special Approval' }]
    )
  ];

  const paymentTypeOptions = [
    { value: '1', label: 'Self-Paid' },
    { value: '2', label: 'Insurance' },
    { value: '3', label: 'ECHS' },
    { value: '4', label: 'CGHS' },
  ];

  const handleSubmit = async (values) => {
    // if (values.feasibility !== "3") delete values.payment_type;

    const payload = {
      ...values,
      feasibility_type: "FINANCIAL",
      id
    };

    await dispatch(updateFeasibility(payload));
    onMarkAsFisable();
    handleCloseModal();
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  });

  const formOptions = [
    {
      label: 'Feasibility',
      type: 'select',
      name: 'feasibility',
      required: true,
      placeholder: 'Select one',
      options: feasibilityOptions
    },
    ...(formik.values.feasibility === "3" || (formik.values.feasibility === "1" && phase_type != "Trial")
      ? [{
        label: 'Payment Type',
        type: 'select',
        name: 'payment_type',
        required: true,
        placeholder: 'Select Payment Type',
        options: paymentTypeOptions
      }]
      : []
    ),
    {
          label: "Select Attachment",
          type: "file",
          name: "media_id",
          multiple: true,
          removeButton: false,
          acceptFormat: SUPPORTED_FORMATS,
          downloadFile: handleDownload,
          placeholder: "Select a File",
          required: false,
          col: 1,
        },
    {
      label: 'Comment',
      type: 'textarea',
      name: 'comment',
      required: true,
      placeholder: 'Enter Comment here'
    }
  ];

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
               {props?.type === 'file' ? (
                <FormControl variant="standard" fullWidth>
                    <FormLabel shrink required={props.required} className="text-black">
                        {props.label}
                    </FormLabel>
                     <FileUploadComponent 
                    field={props}
                    value={formik?.values[props.name]}
                     formData={{ media_id: formik.values[props.name] }}   // MUST be an object
                    setFormData={(cb) => {
                        const newState = cb({ media_id: formik.values[props.name] });
                        formik.setFieldValue(props.name, newState.media_id);
                    }}
                    error={formik?.errors[props.name]}
                    touched={formik?.touched[props.name]}
                  />
                </FormControl>):
              <FormikControl formik={formik} {...props} />}
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton fullWidth type="submit" variant="contained">Submit</LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default FinancialFeasibiltyForm;
